<template>
  <div class="login">
    <header class="login-header">
      <app-bar />
    </header>
    <div class="login-content">
      <auth />
    </div>
  </div>
</template>

<script>
import AppBar from '../components/AppBar'
import Auth from '../components/Auth'

export default {
  name: 'login',
  components: { Auth, AppBar }
}
</script>

<style scoped>
  .login {
    display: grid;
    grid-template-rows: 70px auto;
    grid-template-columns: auto;
    grid-template-areas:
    "header"
    "content";
  }
  .login-header {
    grid-area: header;
  }
  .login-content {
    grid-area: content;
    height: 100%;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto;
    justify-items: center;
    margin-top: 5%;
  }
</style>
